module.exports = __webpack_public_path__ + "img/g7.6f5f6c1c.jpg";